import styled from 'styled-components'

export const ContainerRow = styled.div`
  position: relative;
  width: 100%;
  display: grid;
  grid-template-columns: 100px 1fr;
`

interface VerticalLineProps {
  isFirst: boolean
  isLast: boolean
}

export const VerticalLine = styled.div<VerticalLineProps>`
  position: absolute;
  ${props => (props.isFirst ? `bottom: 0;` : `top: 0;`)}
  left: 50%;
  width: 1px;
  height: ${props => (props.isFirst || props.isLast ? '50%' : '100%')};
  display: ${props => (props.isFirst && props.isLast ? 'none' : 'block')};
  transform: translateX(-50%);

  background: ${props => props.theme.colors.color378ff7};
`
